module.exports = __webpack_public_path__ + "static/scale-model-of-parasail-city-in-clearwater-florida-e9c4e5e67f50fbaadf3d22cf169024c7.png";